import React from 'react';
import { DateTime } from 'luxon';
import { TDR } from 'tdr-common';
import { cn } from '@/lib/utils';
import { getParameterTimes } from '../../../helpers/open-parameters/defaultParameterTimes';
import { analytics, FILTER_CHANGED } from '../../../helpers/analytics';
import { useFilterAnalytics } from '../../../helpers/analytics/filterContext';

export interface MobileOpenTimeSelectorProps {
	restaurant: TDR.Restaurant;
	value?: string;
	onChange: (time: string) => void;
}

const formatDisplay = (hhmm: string) =>
	DateTime.fromFormat(hhmm, 'HH:mm').toFormat('h:mm a').toUpperCase();

export const MobileOpenTimeSelector = ({ restaurant, value, onChange }: MobileOpenTimeSelectorProps) => {
	const times = getParameterTimes(restaurant);
	const filterCtx = useFilterAnalytics('global explore');

	return (
		<div className="grid max-h-[420px] grid-cols-3 gap-2 overflow-y-auto pr-1">
			{times.map(time => {
				const isSelected = time === value;
				return (
					<button
						key={time}
						type="button"
						onClick={() => {
							analytics.track(FILTER_CHANGED, {
								filterName: 'time',
								filterValue: time,
								source: 'open_parameters_time',
								...filterCtx
							});
							onChange(time);
						}}
						className={cn(
							'rounded-2xl border bg-tablz-med-gray-2 px-3 py-3 font-poppins text-base font-semibold text-tablz-text-white-1 hover:bg-tablz-med-gray-6',
							isSelected ? 'border-2 border-tablz-primary-1' : 'border border-tablz-med-gray-4'
						)}
					>
						{formatDisplay(time)}
					</button>
				);
			})}
		</div>
	);
};
